import {
  CreditCardIcon,
  ShieldCheckIcon,
  TruckIcon,
  WrenchIcon
} from '@heroicons/react/20/solid';

const STAGE_TO_GROUP_MAP: Record<string, string> = {
  requested: 'Payment',
  paid: 'Payment',
  'production-started': 'Production',
  'production-completed': 'Production',
  'qa-started': 'QA',
  'qa-completed': 'QA',
  approved: 'QA',
  rejected: 'QA',
  sent: 'Delivery',
  delivered: 'Delivery',
  done: 'Done'
};

const STAGE_LABELS: Record<string, string> = {
  requested: 'Sample Requested',
  paid: 'Sample Paid',
  'production-started': 'Production Started',
  'production-completed': 'Production Completed',
  'qa-started': 'Sample QA Started',
  'qa-completed': 'Sample QA Completed',
  approved: 'Approved for Shipping',
  rejected: 'Sample QA Rejected',
  sent: 'Sample Sent',
  delivered: 'Sample Delivered',
  done: 'Done'
};

const STAGE_ICONS: Record<string, JSX.Element> = {
  Payment: <CreditCardIcon className="w-5 h-5" />,
  Production: <WrenchIcon className="w-5 h-5" />,
  QA: <ShieldCheckIcon className="w-5 h-5" />,
  Delivery: <TruckIcon className="w-5 h-5" />
};

const STAGE_ICONS_SMALL: Record<string, JSX.Element> = {
  requested: <WrenchIcon className="w-4 h-4" />,
  paid: <WrenchIcon className="w-4 h-4" />,
  'production-started': <WrenchIcon className="w-4 h-4" />,
  'production-completed': <WrenchIcon className="w-4 h-4" />,
  'qa-started': <ShieldCheckIcon className="w-4 h-4" />,
  'qa-completed': <ShieldCheckIcon className="w-4 h-4" />,
  approved: <ShieldCheckIcon className="w-4 h-4" />,
  rejected: <ShieldCheckIcon className="w-4 h-4" />,
  sent: <TruckIcon className="w-4 h-4" />,
  delivered: <TruckIcon className="w-4 h-4" />
};

export { STAGE_ICONS, STAGE_ICONS_SMALL, STAGE_LABELS, STAGE_TO_GROUP_MAP };
